<template>
    <div class="page-container">
        <!-- <div class="logo-wrapper" v-if="!isWorkWechat() || wxLogout">
            <img :src="companyInfo.logo" alt="" class="logo">
        </div> -->

        <div class="login-container" v-if="!isWorkWechat() || wxLogout">
            <div class="login-wrapper">
                <div class="login-title">
                    <!--<img src="" alt="" class="login-title-image">-->
                    {{ companyInfo.topDeptName }}
                </div>
                <div class="login-brief">
                    汇学堂学习云平台
                </div>
                <div class="login-content">
                    <div class="login-content-item">
                        <el-input placeholder="手机号" v-model="form.username">
                            <img slot="prefix" src="../assets/img/username.png" alt="" class="login-icon">
                        </el-input>
                    </div>
                    <div class="login-content-item password-wrapper">
                        <div class="password-input-wrapper">
                            <el-input placeholder="验证码" v-model="form.password">
                                <img slot="prefix" src="../assets/img/password.png" alt="" class="login-icon">
                            </el-input>
                        </div>
                        <div v-if="messageBtn == 'send'" class="password-btn" @click="handleMessage">获取</div>
                        <div v-if="messageBtn == 'time'" class="password-btn">{{ countDown }}s</div>
                    </div>
                    <div class="login-btn" @click="login">登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userCompanyInfo, userLogin, workWechatLogin, workWechatAuthorize, getDefaultDept, sendLoginMessage, getLoginCompanyName, justifyAdmin, examAuth } from '@/api/index.js';
import config from '../config';
import getQuery from '@/utils/getQuery'
export default {
    name: '',
    components: {

    },
    data() {
        return {
            companyInfo: {},
            form: {
                username: "",
                password: ""
            },
            messageBtn: 'send',
            countDown: 60 * 5,
            messageData: {},
            passwordEdit: true,
            wxLogout: true,
        }
    },
    mounted() {
        // 判断微信自动登录的域名
        let domains = ['a.saas-dev.taxchina.com', 'zswpx.saas.taxchina.com', 'zswpx.saas-test.taxchina.com']
        let isPassDomain = domains.includes(document.domain)
        this.wxLogout = true



        if (this.isWorkWechat() && !window.sessionStorage.getItem('wxLogout') && isPassDomain) {
            this.wxLogout = false

        }
        this.justifyActiveAdmin();
        // 如果是企业微信
        var token = window.localStorage.getItem("token");
       
        if (this.isWorkWechat() && !this.wxLogout && !token && isPassDomain) {

            this.workWechatInit()
        }
    },
    methods: {
        justifyActiveAdmin() {
            const openUrl = config.openUrl;
            justifyAdmin({}, {}).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    if (data) {
                        this.justifyHasLogin();
                        this.getCompanyName();
                    } else {
                        window.location.href = openUrl + '/404';
                    }
                } else {
                    window.location.href = openUrl + '/404';
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        justifyHasLogin() {
            var token = window.localStorage.getItem("token");
            var dept = window.localStorage.getItem("dept");
            if (token && token != '' && dept && dept != '') {

                this.$router.push(`/index`);
                //  this.$router.push(`/index/enterprise-center/${dept}/${token}`);
            }
        },
        getCompanyName() {
            const baseUrl = config.baseUrl;
            getLoginCompanyName(baseUrl, {}, {}).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.companyInfo = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        captcha() {
            var _this = this;
            var captcha = new TencentCaptcha('2000842234',
                function (res) {
                    if (res.ret == 0) {
                        _this.messageData = res;
                        _this.countTime(res);
                    }
                }
            );
            captcha.show();
        },
        handleMessage() {
            var username = this.form.username;
            if (username == '') {
                this.$message.error('请输入手机号');
                return false;
            }
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(username))) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            this.captcha();
        },
        countTime(data) {
            this.messageBtn = 'time';
            this.passwordEdit = false;
            var num = this.countDown;
            var _this = this;
            var countTimeNum = setInterval(function () {
                if (num > 0) {
                    num--;
                    _this.countDown = num;
                } else {
                    clearInterval(countTimeNum);
                    _this.messageBtn = 'send';
                    _this.countDown = 60 * 5;
                }
            }, 1000);
            this.sendMessage(data);
        },
        sendMessage(params) {
            sendLoginMessage({
                "mobile": this.form.username,
                "randstr": params.randstr,
                "ticket": params.ticket
            }, {}).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '验证码已发送',
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        login() {
            var form = this.form;//15615123027
            var username = form.username;
            var password = form.password;
            if (username == '') {
                this.$message.error('请输入手机号');
                return false;
            }
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(username))) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            if (password == '') {
                this.$message.error('请输入验证码');
                return false;
            }
            var messageData = this.messageData;
            if (!messageData.randstr || messageData.randstr == '') {
                this.$message.error('请完成验证后获取验证码');
                return false;
            }
            var _this = this;
            userLogin({
                "captcha": password,
                "clientType": 3,
                "mobile": username,
                "randstr": messageData.randstr
            }, {}).then(res => {
                if (res.code == 200) {
                    var data = res.data;

                    window.localStorage.setItem('token', data.token);
                    _this.getUserDept(data.token, form);
                } else {
                    this.$message.error("验证码错误");
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
            /*var token=`
                Authorization:Saas eyJhbGciOiJIUzUxMiJ9.eyJjbGllbnRUeXBlIjoiMyIsInVzZXJJZCI6IjEwMCIsInVzZXJLZXkiOiI5ZGUwZmMzNy03OTE5LTQ2YzctODgwZC0wMDdiODU3ZmFkZjIifQ.mRr1-iNvLlhuRfj3eCjOGFeGDcAGy94ndhh6CvUbxbJpp3WArUCBsobg2x52qarVdAtuMrekxUedGeKprftkIQ`; 
                var dept=349;
            window.localStorage.setItem('token',token);
            window.localStorage.setItem('dept',dept);
            this.$router.push(`/index/enterprise-center/${dept}/${token}`);*/
        },
        //2024-1/16号大改版前代码
        // getUserDept(token, form) {
        //     getDefaultDept({}, {
        //         Authorization: token,
        //         DeptId: '0'
        //     }).then(res => {
        //         if (res.code == 200) {
        //             var data = res.data;
        //            // console.log(data, "***********")
        //             // form["dept"] = data;
        //             // window.localStorage.setItem('dept', form.dept);
        //             // this.$router.push(`/index/enterprise-center/${form.dept}/${token}`);
        //         } else {
        //             if (this.isWorkWechat()) {
        //                 window.localStorage.clear();
        //             }
        //             this.$message.error(res.msg);
        //         }
        //         return;
        //     }).catch(err => {
        //        // console.log(err);
        //     });
        // },

        //2024-1/16号大改版后代码
        async getUserDept(token, form) {
            userCompanyInfo({}, {
                Authorization: token,

            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;

                    window.localStorage.setItem('TopDeptId', data.topDeptId);
                    window.localStorage.setItem('dept', data.deptId);
                    window.localStorage.setItem('token', token);

                    //  this.$router.push
                    //  this.$router.push(`/index/enterprise-center/${data.deptId}/${token}`);
                    this.$router.push(`/index`);
                    //  aleat('111111111')
              

                } else {
                    if (this.isWorkWechat()) {
                        window.localStorage.clear();
                    }
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getUserType(id, token) {
            examAuth({}, {
                Authorization: token,
                TopDeptId: id
            }).then(res => {
                if (res.code == 200) {
                    // "role": 0, //用户角色(0:普通用户；1：管理员；2：超级管理员）
                    //     "assign": 1 //1=米诺测评已分配，0=米诺测评未被分配
                    window.localStorage.setItem('mnUserRole', res.data.role);
                    window.localStorage.setItem('mnUserAssign', res.data.assign);
                }
            }).catch(err => {
                // console.log(err);
            });
        },
        // 企业微信检验是否存在code
        workWechatInit() {
            if (!getQuery('code')) {
                this.getWorkWechatAuthorize()
            } else {
                this.workWechatLoginHandler()
            }
        },
        // 判断设备企业微信
        isWorkWechat() {
            //获取user-agaent标识头
            var ua = window.navigator.userAgent.toLowerCase();
            console.log(ua, 'ua------ window.navigator.userAgent.toLowerCase();----------------------------------------------------')
            //判断ua和微信浏览器的标识头是否匹配
            if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                return true;
            } else {
                return false;
            }
        },
        // 企业微信登录
        getWorkWechatAuthorize() {
            const returnUrl = encodeURIComponent(location.href)
            workWechatAuthorize({
                returnUrl,
            }, {}).then(res => {
                if (res.code == 200) {
                    location.href = res.msg
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 企业微信登录
        workWechatLoginHandler() {
            const code = getQuery('code')
            workWechatLogin({
                code,
                clientType: 3,
            }, {}).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    window.localStorage.setItem('token', data.token);
                    window.localStorage.setItem('dept', data.deptId);
                    //  this.$router.push(`/index/enterprise-center/${data.deptId}/${data.token}`);
                    this.$router.push(`/index`);
                } else {
                    if (res.msg.indexOf('调用企业微信接口失败') === -1) {
                        this.$message.error(res.msg);
                    }
                    this.wxLogout = true
                }
                return;
            }).catch(err => {
                this.wxLogout = true
                // console.log(err);
            });
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    height: 100vh;
    background-image: url(../assets/img/bg.png);
    background-repeat: no-repeat;
    background-origin: center;
    background-size: cover;
    background-position: center center;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-wrapper {
    position: absolute;
    top: 41px;
    left: 78px;
}

.logo {
    width: 172px;
    height: 89px;
}

.login-container {
    width: 668px;
    height: 576px;
    background: #F5FBFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-wrapper {
    width: 620px;
    height: 528px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border: 1px solid #F0F0F3;
}

.login-title {
    height: 37px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 37px;
    text-align: center;
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-title-image {
    width: 37px;
    height: 37px;
    margin-right: 5px;
}

.login-brief {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 28px;
}

.login-content {
    width: 360px;
    margin: 0 auto;
    margin-top: 56px;
}

.login-icon {
    width: 16px;
    height: 17px;
    position: relative;
    top: 10px;
    left: 5px;
}

.password-wrapper {
    margin-top: 24px;
    display: flex;
}

.password-input-wrapper {
    width: 250px;
}

.password-btn {
    flex: 1;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #4F79ED;
    margin-left: 10px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #4F79ED;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.password-btn:hover {
    cursor: pointer;
    color: #fff;
    background: #4F79ED;
}

.login-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%);
    border-radius: 22px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 81px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.login-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}
</style>


